import React, { FC } from 'react';

import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListCtas: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListCtas.slug = block.slug;
ListCtas.title = block.title;
